module.exports = __webpack_public_path__ + "static/img/6.160d8c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/6.png
// module id = Tp6f
// module chunks = 0